// Mock data for Ayan Saha's Portfolio

export const profileData = {
  name: "Ayan Saha",
  title: "Software Engineer",
  tagline: "Crafting seamless digital experiences with MERN stack",
  email: "ayansaha808@gmail.com",
  linkedin: "https://linkedin.com/in/ayansaha23",
  github: "https://github.com/ayansaha20",
  location: "India",
  about: `Passionate Software Engineer specializing in building robust, scalable web applications using the MERN stack. With a keen eye for clean code and user-centric design, I transform complex problems into elegant solutions. Currently crafting innovative products at GoodWorkLabs, I've had the privilege of working on impactful projects across EdTech, HR Tech, and Enterprise platforms.`
};

export const experiences = [
  {
    id: 1,
    company: "GoodWorkLabs",
    role: "Software Engineer",
    duration: "Present",
    type: "current",
    description: "Building innovative software solutions and contributing to multiple client projects. Working with modern tech stack including React, Node.js, and cloud technologies.",
    technologies: ["React", "Node.js", "MongoDB", "AWS"]
  }
];

export const projects = [
  {
    id: 1,
    title: "NetSkill App",
    category: "EdTech Platform",
    description: "A comprehensive skill development and learning platform designed to enhance professional capabilities through interactive courses and assessments.",
    technologies: ["React", "Node.js", "MongoDB", "Express"],
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80",
    featured: true
  },
  {
    id: 2,
    title: "E&Y - Etim India Platform",
    category: "Enterprise Solution",
    description: "Enterprise-grade platform developed for Ernst & Young's Etim India initiative, streamlining business processes and data management.",
    technologies: ["React", "Node.js", "PostgreSQL", "Azure"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    featured: true
  },
  {
    id: 3,
    title: "EkStep - AI Language Learning",
    category: "AI/EdTech",
    description: "AI-powered language learning application that uses advanced algorithms to personalize the learning journey and improve language acquisition.",
    technologies: ["React", "Python", "TensorFlow", "Node.js"],
    image: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=800&q=80",
    featured: true
  },
  {
    id: 4,
    title: "TestRocket",
    category: "Assessment Platform",
    description: "Dynamic testing and assessment platform enabling organizations to create, conduct, and analyze examinations with comprehensive analytics.",
    technologies: ["React", "Express", "MongoDB", "Redis"],
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80",
    featured: false
  },
  {
    id: 5,
    title: "RocketAts",
    category: "HR Tech",
    description: "Applicant Tracking System designed to streamline recruitment workflows, from candidate sourcing to hiring decisions.",
    technologies: ["React", "Node.js", "MongoDB", "GraphQL"],
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
    featured: false
  }
];

export const skills = [
  { name: "React.js", category: "Frontend", level: 95 },
  { name: "Node.js", category: "Backend", level: 90 },
  { name: "MongoDB", category: "Database", level: 88 },
  { name: "Express.js", category: "Backend", level: 90 },
  { name: "JavaScript", category: "Language", level: 95 },
  { name: "TypeScript", category: "Language", level: 85 },
  { name: "PostgreSQL", category: "Database", level: 80 },
  { name: "AWS", category: "Cloud", level: 75 },
  { name: "Git", category: "Tools", level: 90 },
  { name: "Docker", category: "DevOps", level: 70 },
  { name: "GraphQL", category: "API", level: 78 },
  { name: "Redis", category: "Database", level: 72 }
];

export const testimonials = [
  {
    id: 1,
    name: "Project Lead",
    role: "Client Partner",
    content: "Ayan consistently delivers high-quality code and brings innovative solutions to complex problems. His expertise in the MERN stack has been invaluable to our team.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80"
  },
  {
    id: 2,
    name: "Tech Manager",
    role: "Client Partner",
    content: "Working with Ayan was a great experience. His technical skills and attention to detail helped us deliver a robust AI-powered application.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80"
  }
];

export const navLinks = [
  { name: "About", href: "#about" },
  { name: "Experience", href: "#experience" },
  { name: "Projects", href: "#projects" },
  { name: "Skills", href: "#skills" },
  { name: "Contact", href: "#contact" }
];
